import { Injectable, Injector } from '@angular/core';

import { SummaryService } from './summary.service';
import { BaseReportService } from './reportBase.service';
import type { IGetReportData, TReportOptions, TSummaryCampaignDailyValues } from '@shared/models';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Injectable()
export class ReportCampaignSummaryService extends BaseReportService implements IGetReportData {
    private summaryService: SummaryService;

    constructor(injector: Injector) {
        super(injector);
        this.summaryService = injector.get(SummaryService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];
        let reportColValues: string[];
        let rowInfo: any;
        let totalRecipients = 0;
        let dailyValues: TSummaryCampaignDailyValues[] = [];

        // Get the daily values from the summary service.
        try {
            const startingDate = this.options.startingDate;
            const endingDate = this.options.endingDate;
            const obj = await this.summaryService.getCampaignUidsByDateRange(startingDate, endingDate);

            dailyValues = obj.dailyValues as TSummaryCampaignDailyValues[];
        } catch (error) {
            throw new Error('Error in ReportCampaignSummaryService. Unable to get daily values: ' + error);
        }

        // Process the daily values to build the report rows.
        try {
            for (const daily of dailyValues) {
                const date = this.formatDateTime(daily.date);
                const numRecipients = daily.count.toString();
    
                reportColValues = [date, numRecipients];
                rowInfo = this.buildRowInfo(reportColValues, 'data');
                allRows.push(rowInfo);
    
                totalRecipients += daily.count;
            }
    
            // Calculate summary totals rows here.
            const totalCampaigns = dailyValues.length.toString();
    
            reportColValues = ['Summary:', ' '];
            rowInfo = this.buildRowInfo(reportColValues, 'summary');
            allRows.push(rowInfo);
    
            reportColValues = [totalCampaigns, totalRecipients.toString()];
            rowInfo = this.buildRowInfo(reportColValues, 'summary');
            allRows.push(rowInfo);
    
            // End of report data
            allRows.push(undefined);
            const reportData = { 'data': allRows };
            return reportData;
        } catch (error) {
            throw new Error('Error in ReportCampaignSummaryService. Unable to build the report: ' + error);
        }
    }
}
